import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mainViewMixin from '../mainViewMixin';
export default {
  name: 'ViewNiotaClassicDeviceTypesDeviceTypesList',
  mixins: [mainViewMixin],
  data: function data() {
    return {
      accountId: false,
      findCertified: false,
      editedItem: null
    };
  },
  computed: {
    headerBG: function headerBG() {
      return './img/consumer.png';
    },
    deviceTypeButtons: function deviceTypeButtons() {
      return [{
        title: this.$i18n_t('NiotaClassic.DeviceTypes.filterDigimondoCertified'),
        icon: "".concat(!this.findCertified ? 'fal' : 'fas', " fa-filter"),
        action: 'toogleCertifiedFilter',
        valid: true
      }, {
        title: this.$i18n_t('NiotaClassic.DeviceTypes.filterUsedDeviceTypes'),
        icon: "".concat(!this.accountId ? 'fal' : 'fas', " fa-filter"),
        action: 'toggleAccountFilter',
        valid: true
      }, {
        // title: this.$i18n_t('NiotaClassic.DeviceTypes.filterUsedDeviceTypes'),
        icon: 'fal fa-undo',
        action: 'resetFilter',
        valid: true
      }].concat(_toConsumableArray(this.buttons));
    }
  },
  watch: {},
  created: function created() {
    this.setFilterFromQueryParams();
  },
  methods: {
    setFilterFromQueryParams: function setFilterFromQueryParams() {
      var filterUsed = this.$route.query.filterUsed;
      var filterCertified = this.$route.query.filterCertified;

      if (filterUsed) {
        this.accountId = true;
      }

      if (filterCertified) {
        this.findCertified = true;
      }
    },
    toggleAccountFilter: function toggleAccountFilter() {
      this.accountId = !this.accountId;
    },
    toogleCertifiedFilter: function toogleCertifiedFilter() {
      this.findCertified = !this.findCertified;
    },
    editItem: function editItem(item) {
      this.editedItem = item;
      this.formDialog = true;
    },
    updateList: function updateList() {
      this.$refs.list.fetchList();
    },
    resetFilter: function resetFilter() {
      this.accountId = false;
      this.findCertified = false;
    }
  }
};